import React, { useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTheme } from "../../_core/ThemeProvider";
import { MoonIcon, SunIcon } from "../../../../app/components/jds/icons";

export function ThemeToggle() {
  const { theme, toggle, lightOnly } = useTheme();
  const wrapRef = useRef(null);
  // modo efetivo: páginas light-only forçam o claro mesmo com dark salvo
  const dark = theme === "dark" && !lightOnly;
  const action = lightOnly
    ? "Modo escuro indisponível nesta página"
    : `Mudar para ${dark ? "modo claro" : "modo escuro"}`;

  return (
    // container: o tooltip NÃO pode ir para document.body. No React 17, o
    // primeiro portal em body registra os listeners do React lá, e aí o
    // flushPassiveEffects roda no meio do mesmo click que abriu um
    // react-bootstrap Dropdown (react-overlays 3.2): o rootClose registrado
    // nesse instante fecha o menu na hora (pill "Olá, <nome>" nunca abre).
    <OverlayTrigger
      placement="bottom"
      container={wrapRef}
      overlay={<Tooltip id="theme-toggle-tooltip">{action}</Tooltip>}
    >
      <div className="topbar-item" ref={wrapRef}>
        <button
          type="button"
          role="switch"
          aria-checked={dark}
          aria-label="Modo escuro"
          aria-disabled={lightOnly || undefined}
          className={`theme-switch${dark ? " is-dark" : ""}${
            lightOnly ? " is-disabled" : ""
          }`}
          onClick={lightOnly ? undefined : toggle}
        >
          <span className="theme-switch__glyph theme-switch__glyph--sun">
            <SunIcon />
          </span>
          <span className="theme-switch__glyph theme-switch__glyph--moon">
            <MoonIcon />
          </span>
          <span className="theme-switch__thumb">
            <span className="theme-switch__icon theme-switch__icon--sun">
              <SunIcon />
            </span>
            <span className="theme-switch__icon theme-switch__icon--moon">
              <MoonIcon />
            </span>
          </span>
        </button>
      </div>
    </OverlayTrigger>
  );
}
